import { DAMAGE_CLASS_COLOR_MAP, primary, SC_CATEGORY_COLORS } from '@/theme/colors';

const { DC0, DC1, DC2, DC3, DC4, DC5 } = DAMAGE_CLASS_COLOR_MAP;

export enum AlarmLevels {
  CLEAN = 'Clean',
  ALARM_1 = 'Alarm level 1',
  ALARM_2 = 'Alarm level 2',
  ALARM_3 = 'Alarm level 3',
  ALARM_1_OR_2 = 'Alarm level 1 or 2',
}

export enum DefectLevels {
  DC_0 = 'DC0',
  DC_1 = 'DC1',
  DC_2 = 'DC2',
  DC_3 = 'DC3',
  DC_4 = 'DC4',
  DC_5 = 'DC5',
}

export enum ScCategory {
  SC_0 = 'SC0',
  SC_1 = 'SC1',
  SC_2 = 'SC2',
  SC_3 = 'SC3',
}

export type Recommendations = AlarmLevels | DefectLevels;

type CriticalityLevelMapperProps = {
  [key in AlarmLevels | DefectLevels | ScCategory]: {
    alarmLevel?: string;
    category?: string;
    color: string;
  };
};

export const CriticalityLevelMapper: CriticalityLevelMapperProps = {
  [AlarmLevels.CLEAN]: { alarmLevel: 'Clean', color: primary.LightGrey },
  [AlarmLevels.ALARM_1]: { alarmLevel: '1', color: 'success.main' },
  [AlarmLevels.ALARM_1_OR_2]: { alarmLevel: '1/2', color: 'info.main' },
  [AlarmLevels.ALARM_2]: { alarmLevel: '2', color: 'warning.main' },
  [AlarmLevels.ALARM_3]: { alarmLevel: '3', color: 'error.main' },
  [DefectLevels.DC_0]: { alarmLevel: '0', color: DC0 },
  [DefectLevels.DC_1]: { alarmLevel: '01', color: DC1 },
  [DefectLevels.DC_2]: { alarmLevel: '02', color: DC2 },
  [DefectLevels.DC_3]: { alarmLevel: '03', color: DC3 },
  [DefectLevels.DC_4]: { alarmLevel: '04', color: DC4 },
  [DefectLevels.DC_5]: { alarmLevel: '05', color: DC5 },
  [ScCategory.SC_0]: { category: '0', color: SC_CATEGORY_COLORS.SC0 },
  [ScCategory.SC_1]: { category: '1', color: SC_CATEGORY_COLORS.SC1 },
  [ScCategory.SC_2]: { category: '2', color: SC_CATEGORY_COLORS.SC2 },
  [ScCategory.SC_3]: { category: '3', color: SC_CATEGORY_COLORS.SC3 },
};
